import Image from "next/image";
import { useCallback } from "react";

import HexaLink from "./HexaLink";
/*import "./Hexagon.scss";*/
const hexagonStyles = new Proxy({"Hexagons":"Hexagons-cb406","BaseHexagon":"BaseHexagon-cb406","Hexagon8":"Hexagon8-cb406","Hexagon7":"Hexagon7-cb406","Hexagon6":"Hexagon6-cb406","Hexagon5":"Hexagon5-cb406","Hexagon4":"Hexagon4-cb406","Hexagon3":"Hexagon3-cb406","Hexagon2":"Hexagon2-cb406","Hexagon1":"Hexagon1-cb406","Cybersecurity":"Cybersecurity-cb406","Biometrics":"Biometrics-cb406"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const CLASS_NAMES = [
  hexagonStyles.Hexagon1,
  hexagonStyles.Hexagon2,
  hexagonStyles.Hexagon3,
  hexagonStyles.Hexagon4,
  hexagonStyles.Hexagon5,
  hexagonStyles.Hexagon6,
  hexagonStyles.Hexagon7,
  hexagonStyles.Hexagon8,
];

const Hexagon = ({ idx, to, title, image, onMouse }: any) => {
  const className = CLASS_NAMES[idx - 1];
  const classes = ["Hexagon", className].join(" ");
  const plainTitle = title.replace(/<br\s*\/>/gi, " ").trim();

  const onOver = useCallback(() => {
    onMouse(idx);
  }, [idx, onMouse]);

  const onOut = useCallback(() => {
    onMouse(0);
  }, [onMouse]);

  return (
    <HexaLink to={to} className={classes} onOver={onOver} onOut={onOut}>
      <div className="hexa-border">
        <div className="hexa-bg">
          <div className="hexa-shadow">
            <div className="hexa-selector">
              <h3>{title}</h3>
              {image && (
                <div className="hexa-logo">
                  <Image
                    src={image.url}
                    alt={plainTitle}
                    width={image.width}
                    height={image.height}
                    sizes="120px"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </HexaLink>
  );
};

export default Hexagon;
